/** Join class names, dropping anything falsy. The whole of it. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ')
}
